//#region src/bite_log_olo_pay_kiosk_event.ts
var BiteLogOloPayKioskEvent = /* @__PURE__ */ function(BiteLogOloPayKioskEvent) {
	/** @deprecated This event is not made as of 2025-06-02, Keep until 9/2 for parsing purposes */
	BiteLogOloPayKioskEvent[BiteLogOloPayKioskEvent["PaymentDeprecated"] = 1] = "PaymentDeprecated";
	/** @deprecated This event is not made as of 2025-06-02, Keep until 9/2 for parsing purposes */
	BiteLogOloPayKioskEvent[BiteLogOloPayKioskEvent["PaymentErrorDeprecated"] = 2] = "PaymentErrorDeprecated";
	/** @deprecated This event is not made as of 2025-06-02, Keep until 9/2 for parsing purposes */
	BiteLogOloPayKioskEvent[BiteLogOloPayKioskEvent["RefundDeprecated"] = 3] = "RefundDeprecated";
	/** @deprecated This event is not made as of 2025-06-02, Keep until 9/2 for parsing purposes */
	BiteLogOloPayKioskEvent[BiteLogOloPayKioskEvent["RefundErrorDeprecated"] = 4] = "RefundErrorDeprecated";
	BiteLogOloPayKioskEvent[BiteLogOloPayKioskEvent["TerminalDisconnected"] = 5] = "TerminalDisconnected";
	return BiteLogOloPayKioskEvent;
}(BiteLogOloPayKioskEvent || {});
//#endregion
export { BiteLogOloPayKioskEvent };

//# sourceMappingURL=bite_log_olo_pay_kiosk_event.js.map